<style>
</style>
<template>
<div>
  <v-dialog v-model="iframeDialog" :max-width="width" v-click-outside="onClickOutside">
    <iframe id="iframe" :height="height" :scrolling="scrolling" frameborder="0" :src="redirectUrl"></iframe>
  </v-dialog>
</div>
</template>
<script>
export default {
  name: 'dialog-iframe',
  computed: {
    redirectUrl: {
      get() {
        return this.$iframe.iframe.redirectUrl
      }
    },
    width: {
      get() {
        return this.$iframe.iframe.width
      }
    },
    height: {
      get() {
        return this.$iframe.iframe.height
      }
    },
    scrolling: {
      get() {
        return this.$iframe.iframe.scrolling
      }
    },
    iframeDialog: {
      get() {
        return this.$iframe.iframe.redirectUrl !== null
      },
      set(value) {
        console.debug(value)
      }
    }
  },
  methods: {
    onClickOutside() {
      if (this.iframeDialog) {
        window.postMessage({
          'event': 'close-iframe-message',
          'message': this.$iframe.iframe.backUrl
        }, '*')
      }
    },
  }
}
</script>
